var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220,10H80c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V80C290,41.4,258.6,10,220,10z",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,10H430c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V80C640,41.4,608.6,10,570,10z",
    fill: "#ffeba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920,10H780c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V80C990,41.4,958.6,10,920,10z",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,360H80c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V430C290,391.4,258.6,360,220,360z",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,360H430c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V430C640,391.4,608.6,360,570,360z",
    fill: "#56af91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920,360H780c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V430C990,391.4,958.6,360,920,360z",
    fill: "#e8758c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,710H80c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V780C290,741.4,258.6,710,220,710z",
    fill: "#3f8598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,710H430c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V780C640,741.4,608.6,710,570,710z",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920,710H780c-38.6,0-70,31.4-70,70v140c0,38.6,31.4,70,70,70h140c38.6,0,70-31.4,70-70V780C990,741.4,958.6,710,920,710z",
    fill: "#dee1e5"
  }))))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a93b82d2866065cc17f8dcf675c9a5dd.svg";
export { ForwardRef as ReactComponent };